/*
 * @Description: APP管理
 * @Author: fxg
 * @Date: 2020-06-29 11:18:28
 * @LastEditors: fxg
 * @LastEditTime: 2020-06-29 13:34:36
*/
import request from '@/utils/request'
export const Download = "/base/system/app/export";
export function batchUpdateOrDelete(data) {
  return request({
    url: '/base/system/app/batch_update_or_delete',
    method: 'post',
    data
  })
}
export function getList() {
  return request({
    url: '/base/system/app/get_list',
    method: 'get'
  })
}
export function getDetail() {
  return request({
    url: '/base/system/app/get_detail',
    method: 'get'
  })
}
export function queryPage(data) {
  return request({
    url: '/base/system/app/queryPage',
    method: 'post',
    data
  })
}
export function saveOrUpdate(data) {
  return request({
    url: '/base/system/app/save_or_update',
    method: 'post',
    data
  })
}
export function updateSortNum(data) {
  return request({
    url: '/base/system/app/update_sort_num',
    method: 'post',
    data
  })
}
